"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_date_object_1 = tslib_1.__importDefault(require("react-date-object"));
var persian_1 = tslib_1.__importDefault(require("react-date-object/calendars/persian"));
var gregorian_1 = tslib_1.__importDefault(require("react-date-object/calendars/gregorian"));
function formatDate(data, format, type) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (data) {
        var date = new react_date_object_1["default"](data);
        date.calendar = type === 'gregorian' ? gregorian_1["default"] : persian_1["default"];
        return date.format(format);
    }
    return null;
}
exports["default"] = formatDate;
//# sourceMappingURL=formatDate.js.map